import { useState } from "react";
import { useTellescopeQuery } from "@tellescope/tanstack-query";

export const useFormAccessCodeInfo = (accessCode: string) => {
  // Never served from cache: returning to a form submitted moments ago must show it read-only rather
  // than reopen it for a second submit.
  const {
    data: info,
    isLoading,
    error,
  } = useTellescopeQuery({
    model: "form_responses",
    method: "info_for_access_code",
    request: { accessCode },
    enabled: !!accessCode,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  // Read-only is decided once per access code, from the first load. Submitting here invalidates this
  // query, and judging the refetch would swap the wizard's thanks screen for the read-only view.
  const [arrival, setArrival] = useState<{ accessCode: string; wasSubmitted: boolean }>();
  if (info && arrival?.accessCode !== accessCode) {
    setArrival({ accessCode, wasSubmitted: !!info.response.submittedAt });
  }

  return {
    info,
    isLoading,
    error,
    wasSubmittedOnArrival: arrival?.accessCode === accessCode ? arrival.wasSubmitted : !!info?.response.submittedAt,
  };
};
